import { SectionWrapper } from '@/src/components/Layouts';

export default SectionWrapper;
